import {Component, inject} from '@angular/core'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {MatDivider} from '@angular/material/list'

@Component({
  selector: 'spb-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  imports: [MatMenu, MatMenuItem, MatMenuTrigger, LogoComponent, MatIcon, MatIconButton, MatDivider, ToggleButtonComponent]
})
export class HeaderComponent {
  public service = inject(ConfigService)
}
